import { useEffect } from "react";
import use from "react-promise-suspense";
import { graphql, useFragment } from "react-relay";

import { checkIsPostiesArticle } from "~/components/article/article-render/posties/helpers";
import { eventEmitter } from "~/lib/rosetta/event-emitter";
import { isSsr } from "~/lib/utils";
import type { hooksPaywallPromiseContent$key } from "~/queries/__generated__/hooksPaywallPromiseContent.graphql";

import { usePaywallCheckerContext } from "./contexts";

export const usePaywallPromise = (content_: hooksPaywallPromiseContent$key) => {
  const { setPaywallMap } = usePaywallCheckerContext();
  const content = useFragment(
    graphql`
      fragment hooksPaywallPromiseContent on Content {
        entityId
        ...helpersCheckIsPostiesArticle
      }
    `,
    content_,
  );

  const isPosties = checkIsPostiesArticle(content);
  const isShowInlinePaywall = use(
    (_entityId: string, _: string) => {
      if (isSsr() || isPosties) return Promise.resolve(undefined);
      return new Promise<boolean>(resolve => {
        const handler = (value: boolean) => {
          resolve(value);
          eventEmitter.removeListener("showInlineWall", handler);
        };
        eventEmitter.on("showInlineWall", handler);
      });
    },
    [content.entityId, "usePaywallPromise"],
  );

  useEffect(() => {
    if (isShowInlinePaywall === undefined) return;
    setPaywallMap?.(paywallMap => ({
      ...paywallMap,
      [content.entityId]: isShowInlinePaywall,
    }));
  }, [content.entityId, isShowInlinePaywall, setPaywallMap]);

  return isShowInlinePaywall;
};
